export const createShadows = () => [
    'none',
    '0px 1px 2px rgba(0, 0, 0, 0.34), 0px 0px 0px 1px rgba(255, 255, 255, 0.02)',
    '0px 2px 4px rgba(0, 0, 0, 0.36), 0px 0px 0px 1px rgba(255, 255, 255, 0.02)',
    '0px 4px 8px rgba(0, 0, 0, 0.38), 0px 0px 0px 1px rgba(255, 255, 255, 0.02)',
    '0px 6px 12px rgba(0, 0, 0, 0.4), 0px 0px 0px 1px rgba(255, 255, 255, 0.03)',
    '0px 8px 16px rgba(0, 0, 0, 0.42), 0px 0px 0px 1px rgba(255, 255, 255, 0.03)',
    '0px 10px 20px rgba(0, 0, 0, 0.44), 0px 0px 0px 1px rgba(255, 255, 255, 0.03)',
    '0px 12px 24px rgba(0, 0, 0, 0.46), 0px 0px 0px 1px rgba(255, 255, 255, 0.03)',
    '0px 14px 28px rgba(0, 0, 0, 0.48), 0px 0px 0px 1px rgba(255, 255, 255, 0.04)',
    '0px 16px 32px rgba(0, 0, 0, 0.5), 0px 0px 0px 1px rgba(255, 255, 255, 0.04)',
    '0px 18px 36px rgba(0, 0, 0, 0.52), 0px 0px 0px 1px rgba(255, 255, 255, 0.04)',
    '0px 20px 40px rgba(0, 0, 0, 0.54), 0px 0px 0px 1px rgba(255, 255, 255, 0.04)',
    '0px 22px 44px rgba(0, 0, 0, 0.56), 0px 0px 0px 1px rgba(255, 255, 255, 0.05)',
    '0px 24px 48px rgba(0, 0, 0, 0.58), 0px 0px 0px 1px rgba(255, 255, 255, 0.05)',
    '0px 26px 52px rgba(0, 0, 0, 0.6), 0px 0px 0px 1px rgba(255, 255, 255, 0.05)',
    '0px 28px 56px rgba(0, 0, 0, 0.62), 0px 0px 0px 1px rgba(255, 255, 255, 0.05)',
    '0px 30px 60px rgba(0, 0, 0, 0.64), 0px 0px 0px 1px rgba(255, 255, 255, 0.06)',
    '0px 32px 64px rgba(0, 0, 0, 0.66), 0px 0px 0px 1px rgba(255, 255, 255, 0.06)',
    '0px 34px 68px rgba(0, 0, 0, 0.68), 0px 0px 0px 1px rgba(255, 255, 255, 0.06)',
    '0px 36px 72px rgba(0, 0, 0, 0.7), 0px 0px 0px 1px rgba(255, 255, 255, 0.06)',
    '0px 38px 76px rgba(0, 0, 0, 0.72), 0px 0px 0px 1px rgba(255, 255, 255, 0.07)',
    '0px 40px 80px rgba(0, 0, 0, 0.74), 0px 0px 0px 1px rgba(255, 255, 255, 0.07)',
    '0px 42px 84px rgba(0, 0, 0, 0.76), 0px 0px 0px 1px rgba(255, 255, 255, 0.07)',
    '0px 44px 88px rgba(0, 0, 0, 0.78), 0px 0px 0px 1px rgba(255, 255, 255, 0.08)',
    '0px 46px 92px rgba(0, 0, 0, 0.8), 0px 0px 0px 1px rgba(255, 255, 255, 0.08)'
]
